import { THEME_PRIMARY, THEME_HOVER } from "@src/theme"
import styled from "styled-components"

export const TotalText = styled.div`
  display: flex;
  align-items: center;
  color: ${THEME_PRIMARY};
  margin-top: 16px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    text-decoration: underline;
    color: ${THEME_HOVER};
  }
`
